// 휴대폰 «글자 크기» 확대 감지 — 순수 모듈(Firebase·React import 0).
//
// 🔴 2026-10-21 way 실기기: 폰 글자 크기를 키우면 승객 홈의 지도·노선도가 잘 안 보이고 잘린다.
//    안드로이드 앱(WebView)·크롬은 시스템 글자 크기를 따라 **글자만** 키운다 — px 로 고정한
//    칸(높이·폭)은 그대로라 글자가 칸을 넘친다. 그리고 글자가 커진 만큼 위·아래 시트가 지도를
//    밀어 지도가 바닥값(150px)까지 눌린다.
//    → 고정 px 칸은 em 으로 바꿔 넘침을 없애고(배율 1 에서는 픽셀 그대로), 글자가 크게 잡히면
//      홈 위·아래를 «지도 크게» 와 같은 압축형으로 그려 지도 몫을 돌려준다.
//
// 재는 법 — 두 가지 중 큰 값:
//   ① 화면 밖 측정 글자: `font-size:100px; line-height:1` 인 inline-block 의 높이 = 실제로 쓰인 글자 크기.
//      (line-height 1 이라 글꼴 모양과 무관하게 높이 = 글자 크기다.)
//   ② 실제 화면 글자(선택): 우리가 px 로 정한 글자의 계산된 크기 ÷ 정한 값.
//      ①만 믿지 않는 이유 — 안드로이드의 글자 확대는 «글자 자동 크기 조정» 경로로 들어가는데
//      화면 밖·절대 위치 글자는 그 대상에서 빠질 수 있다. 실제 글자를 함께 재면 둘 중 하나는 잡힌다.
// 모르면 1(= 확대 없음 = 현행 화면).

export const BIG_TEXT_SCALE = 1.2;   // 이 배율 이상이면 압축형(안드로이드 «크게» 단계 ≈ 1.15~1.3 · «아주 크게» 1.3↑)
export const NARROW_VIEWPORT_PX = 330; // 크롬 «페이지 확대» 방식은 글자 대신 화면 폭을 줄인다(360px 폰 × 1.15 = 313)

const clampScale = (s) => (Number.isFinite(s) && s > 0.5 && s < 4 ? Math.round(s * 100) / 100 : 1);

/**
 * @param {Document} doc
 * @param {{el?: Element|null, px?: number}} [ref] 실제 화면 글자와 그 글자에 정한 px 값
 * @returns {number} 글자 배율(1 = 확대 없음)
 */
export function measureTextScale(doc, ref = {}) {
  let probe = 1;
  try {
    if (doc && doc.body && typeof doc.createElement === "function") {
      const el = doc.createElement("span");
      el.setAttribute("aria-hidden", "true");
      el.style.cssText = "position:absolute;left:-9999px;top:0;visibility:hidden;display:inline-block;"
        + "font-size:100px;line-height:1;padding:0;border:0;margin:0;white-space:nowrap;pointer-events:none";
      el.textContent = "가";
      doc.body.appendChild(el);
      probe = clampScale(el.getBoundingClientRect().height / 100);
      doc.body.removeChild(el);
    }
  } catch { probe = 1; }

  let real = 1;
  try {
    const { el, px } = ref || {};
    const view = doc && doc.defaultView;
    if (el && px > 0 && view && typeof view.getComputedStyle === "function") {
      real = clampScale(parseFloat(view.getComputedStyle(el).fontSize) / px);
    }
  } catch { real = 1; }

  return Math.max(probe, real);
}

/**
 * 압축형으로 그릴지. 글자 배율이 크거나(안드로이드 앱·크롬 글자 확대) 화면 폭이 아주 좁을 때
 * (크롬 페이지 확대 · 아주 작은 폰).
 * @param {number} scale
 * @param {number} [viewportWidth]
 */
export function isBigText(scale, viewportWidth) {
  if (Number.isFinite(scale) && scale >= BIG_TEXT_SCALE) return true;
  return Number.isFinite(viewportWidth) && viewportWidth > 0 && viewportWidth < NARROW_VIEWPORT_PX;
}
